import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { db } from "../FirebaseConfig";
import Header from "./Header";
import Footer from "./Footer";
import { FaFacebook, FaLinkedin, FaStar } from "react-icons/fa";
import { TbBrandFiverr } from "react-icons/tb";
import { RiArrowRightUpLine } from "react-icons/ri";
import { FaUpwork, FaXTwitter } from "react-icons/fa6";

const MentorDetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [mentor, setMentor] = useState(null);

  // Fetch mentor data from Firestore
  useEffect(() => {
    const fetchMentorDetails = async () => {
      try {
        const docRef = doc(db, "courses", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setMentor({ id: docSnap.id, ...docSnap.data() });
        } else {
          toast.error("Mentor not found");
        }
      } catch (error) {
        toast.error(`Failed to fetch mentor details: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchMentorDetails();
  }, [id]);

  // Generate WhatsApp link for enrollment
  const generateWhatsAppLink = (mentorName, courseName) => {
    const phoneNumber = "+923204192824";
    const message = `Hi Anum, I need to enroll in ${mentorName}'s ${courseName} course.`;
    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-logo"></div>
      </div>
    );
  }

  if (!mentor) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-xl text-gray-600">Mentor not found</p>
      </div>
    );
  }

  return (
    <>
      <Header />
      <section className="relative bg-gray-100 py-12 md:pb-24">
        <div className="container mx-auto px-6 md:px-24">
          {/* Hero Section */}
          <div className="flex flex-col md:flex-row items-center bg-white rounded-lg shadow-xl p-8 mb-8">
            <div className="relative mb-6 md:mb-0 md:mr-8">
              <img
                src={mentor.pictureUrl || "https://via.placeholder.com/150"}
                alt={mentor.name}
                className="w-32 h-32 md:w-48 md:h-48 object-cover border-4 "
              />
            </div>
            <div className="text-center md:text-left">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
                {mentor.name}
              </h1>
              <h2 className="text-xl md:text-2xl text-logo font-semibold">
                {mentor.coursename}
              </h2>
              <div className="flex justify-center md:justify-start items-center gap-1 mt-2">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} className="text-yellow-400" />
                ))}
                <span className="ml-2 text-gray-600">(5.0)</span>
              </div>
              <p className="text-gray-600 mt-2">{mentor.region || "Global"}</p>
            </div>
          </div>

          {/* Details Section */}
          <div className="grid md:grid-cols-3 gap-8">
            {/* Left Column: Course Details and Skills */}
            <div className="md:col-span-2">
              {/* Course Description */}
              <div className="bg-white rounded-lg shadow-xl p-6 mb-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">
                  Course Description
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {mentor.discription || "No description available."}
                </p>
              </div>

              {/* About Mentor */}
              {/* <div className="bg-white rounded-lg shadow-xl p-6 mb-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">About the Mentor</h3>
                <p className="text-gray-600 leading-relaxed">{mentor.about || 'No bio available.'}</p>
              </div> */}

              {/* Skills Section */}
              {/* <div className="bg-white rounded-lg shadow-xl p-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">Skills Taught</h3>
                <div className="flex flex-wrap gap-2">
                  {mentor.skills?.length > 0 ? (
                    mentor.skills.map((skill, index) => (
                      <span
                        key={index}
                        className="bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-semibold"
                      >
                        {skill}
                      </span>
                    ))
                  ) : (
                    <p className="text-gray-600">No skills listed.</p>
                  )}
                </div>
              </div> */}
            </div>

            {/* Right Column: Enrollment Info */}
            <div className="bg-white rounded-lg shadow-xl p-6 sticky top-20">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Course Details
              </h3>
              <div className="space-y-4">
                <p className="text-gray-600">
                  <span className="font-semibold">Price:</span>{" "}
                  {mentor.charges || "N/A"}
                </p>
                <p className="text-gray-600">
                  <span className="font-semibold">Duration:</span>{" "}
                  {mentor.duration || "N/A"}
                </p>
                <p className="text-gray-600">
                  <span className="font-semibold">Starting Date:</span>{" "}
                  {mentor.starting || "N/A"}
                </p>
                <p className="text-gray-600">
                  <span className="font-semibold">Ending Date:</span>{" "}
                  {mentor.endingdate || "coming soon..."}
                </p>
                <p className="text-gray-600">
                  <span className="font-semibold">Lecture Mode:</span>{" "}
                  {mentor.lectureMode || "coming soon..."}
                </p>
                <p className="text-gray-600">
                  <span className="font-semibold">Lecture Time:</span>{" "}
                  {mentor.lectureTime || "coming soon..."}
                </p>
                <p className="text-gray-600">
                  <span className="font-semibold">Lecture Days:</span>{" "}
                  {mentor.weekdays?.join(", ") || "coming soon..."}
                </p>
                {mentor.portfolio && (
                  <a
                    href={mentor.portfolio}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-orange-500 font-semibold hover:underline"
                  >
                    Portfolio <RiArrowRightUpLine className="ml-1" />
                  </a>
                )}
                <div className="flex gap-4 mt-4">
                  {mentor.socialLinks?.linkedin && (
                    <a
                      href={mentor.socialLinks.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedin
                        size={24}
                        className="text-blue-500 hover:text-blue-600"
                      />
                    </a>
                  )}
                  {mentor.socialLinks?.upwork && (
                    <a
                      href={mentor.socialLinks.upwork}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaUpwork
                        size={24}
                        className="text-green-500 hover:text-green-600"
                      />
                    </a>
                  )}
                  {mentor.socialLinks?.twitter && (
                    <a
                      href={mentor.socialLinks.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaXTwitter
                        size={24}
                        className="text-black hover:text-gray-800"
                      />
                    </a>
                  )}
                  {mentor.socialLinks?.facebook && (
                    <a
                      href={mentor.socialLinks.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook
                        size={24}
                        className="text-orange-500 hover:text-orange-600"
                      />
                    </a>
                  )}
                  {mentor.socialLinks?.fiver && (
                    <a
                      href={mentor.socialLinks.fiver}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <TbBrandFiverr
                        size={24}
                        className="text-green-500 hover:text-green-600"
                      />
                    </a>
                  )}
                </div>
                <a
                  href={generateWhatsAppLink(mentor.name, mentor.coursename)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-full text-center font-semibold shadow-lg hover:from-orange-600 hover:to-red-600 transition-all"
                >
                  Enroll Now
                </a>
              </div>
            </div>
          </div>

          {/* Reviews Section (Placeholder) */}
          <div className="bg-white rounded-lg shadow-xl p-6 mt-8">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Reviews</h3>
            <p className="text-gray-600">
              {mentor.reviews?.length > 0
                ? mentor.reviews.map((review, index) => (
                    <div key={index} className="border-b py-4">
                      <p className="font-semibold">{review.reviewer}</p>
                      <p className="text-gray-600">{review.comment}</p>
                      <div className="flex gap-1 mt-1">
                        {[...Array(review.rating)].map((_, i) => (
                          <FaStar key={i} className="text-yellow-400" />
                        ))}
                      </div>
                    </div>
                  ))
                : "No reviews yet."}
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default MentorDetails;
